import "./App.css";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import NotFound from "./pages/NotFound";
import HomePage from "./pages";
import { LayoutApp } from "./layout/Layout";
import VocsInventory from "./pages/VocsInventory/index";
import Fugitive from "./pages/VocsInventory/Fugitive";
import Flare from "./pages/VocsInventory/Flare";
import TransportationMarketing from "./pages/VocsInventory/TransportationMarketing";
import Tank from "./pages/VocsInventory/Tank";
import WasteWaterTreatment from "./pages/VocsInventory/WasteWaterTreatment";
import SetupStackInfo from "./pages/VocsInventory/Combustion/SetupStackInformation";
import SetupFuelVolumeAndDensity from "./pages/VocsInventory/Combustion/SetupVolumneAndDensity";
import { Login } from "./pages/Login";
import { Unauthorized } from "./pages/Unauthorized";
import { ConfigProvider } from "antd";
import MyTask from "./pages/MyTask";
import Production from "./pages/Production";
import Target from "./pages/Target";
import Report from "./pages/Report";
import Dashboard from "./pages/Dashboard";
import Status from "./pages/Status";
import Setting from "./pages/Setting";
import SettingUserManagement from "./pages/Setting/UserManagement";
import SettingCompany from "./pages/Setting/Company";
import SettingCalculation from "./pages/Setting/Masterdata";
import ManualFuelvolume from "./pages/VocsInventory/Combustion/ManualFuelVolume";
import ManualSampling from "./pages/VocsInventory/Combustion/ManualSampling";
import ReportFuelVolume from "./pages/VocsInventory/Combustion/ReportFuelVolume";
import ReportVocEmission from "./pages/VocsInventory/Combustion/ReportVocEmission";
import HistoryCombustion from "./pages/VocsInventory/Combustion/History";
import SetupFlareVolume from "./pages/VocsInventory/Flare/SetupFlareVolume";
import ReportFlareFuelVolume from "./pages/VocsInventory/Flare/ReportFlareFuelVolume";
import ReportFlareVocEmission from "./pages/VocsInventory/Flare/ReportFlareVocEmission";
import ReportGovernment from "./pages/VocsInventory/Flare/ReportGovernment";
import FlareHistory from "./pages/VocsInventory/Flare/History";
import SetupLoadingInfo from "./pages/VocsInventory/TransportationMarketing/SetupLoadingInfo";
import TMManualVolume from "./pages/VocsInventory/TransportationMarketing/ManualVolume";
import TMReportChemVolume from "./pages/VocsInventory/TransportationMarketing/ReportChemicalVolume";
import TMReportVocEmission from "./pages/VocsInventory/TransportationMarketing/ReportVocEmission";
import TMHistory from "./pages/VocsInventory/TransportationMarketing/History";
import ManualFuelVolume from "./pages/VocsInventory/Flare/ManualVolume";
import SetupTankInfo from "./pages/VocsInventory/Tank/SetupTankInfo";
import TankManualVolume from "./pages/VocsInventory/Tank/ManualVolumeTank";
import TankReportVocEmission from "./pages/VocsInventory/Tank/ReportVocEmission";
import TankHistory from "./pages/VocsInventory/Tank/History";
import WWTSetupInformation from "./pages/VocsInventory/WasteWaterTreatment/SetupInformation";
import ManualVocWater from "./pages/VocsInventory/WasteWaterTreatment/ManualVocWater";
import WWTReportVocEmission from "./pages/VocsInventory/WasteWaterTreatment/ReportVocEmission";
import WWTHistory from "./pages/VocsInventory/WasteWaterTreatment/History";
import { antdTheme } from "./utils/antd-theme";
import SetupHeatingValue from "./pages/VocsInventory/Flare/SetupHeatingValue";
import { Helmet, HelmetProvider } from "react-helmet-async";
import MonitoringStatus from "./pages/VocsInventory/Fugitive/MonitoringStatus";
import StopVoc from "./pages/VocsInventory/Fugitive/StopVoc";
import ReportFugitiveFuelVolume from "./pages/VocsInventory/Fugitive/ReportVocSeries";
import ReportFugitiveVocEmission from "./pages/VocsInventory/Fugitive/ReportFugitiveVocEmission";
import FugitiveHistory from "./pages/VocsInventory/Fugitive/History";
import SettingJob from "./pages/Setting/Job";
import SettingHistory from "./pages/Setting/History";
import Others from "./pages/VocsInventory/Others";

import OtherFillSamplingResult from "./pages/VocsInventory/Others/FillSamplingResult";
import OthersFillEmission from "./pages/VocsInventory/Others/FillEmission";
import OthersReport from "./pages/VocsInventory/Others/Report/Report";
import OthersHistory from "./pages/VocsInventory/Others/History";
import OthersInformation from "./pages/VocsInventory/Others/Information";

const App = (): React.ReactElement => {
  return (
    <HelmetProvider>
      <Helmet>
        <title>VOCs</title>
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
        />
      </Helmet>
      <ConfigProvider theme={antdTheme()}>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route
                path="/"
                element={
                  <LayoutApp>
                    <HomePage />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/my-task"
                element={
                  <LayoutApp>
                    <MyTask />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/production"
                element={
                  <LayoutApp>
                    <Production />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/target"
                element={
                  <LayoutApp>
                    <Target />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/report"
                element={
                  <LayoutApp>
                    <Report />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/dashboard"
                element={
                  <LayoutApp>
                    <Dashboard />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/status"
                element={
                  <LayoutApp>
                    <Status />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/setting"
                element={
                  <LayoutApp>
                    <Setting />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/setting/company"
                element={
                  <LayoutApp>
                    <SettingCompany />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/setting/user-management"
                element={
                  <LayoutApp>
                    <SettingUserManagement />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/setting/masterdata"
                element={
                  <LayoutApp>
                    <SettingCalculation />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/setting/job"
                element={
                  <LayoutApp>
                    <SettingJob />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/setting/history"
                element={
                  <LayoutApp>
                    <SettingHistory />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory"
                element={
                  <LayoutApp>
                    <VocsInventory />
                  </LayoutApp>
                }
              ></Route>

              {/* FUJITIVE ZONE */}
              <Route
                path="/vocs-inventory/fugitive/information-voc-result"
                element={
                  <LayoutApp>
                    <Fugitive />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/fugitive/information-monitoring-status"
                element={
                  <LayoutApp>
                    <MonitoringStatus />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/fugitive/information-stop-voc"
                element={
                  <LayoutApp>
                    <StopVoc />
                  </LayoutApp>
                }
              ></Route>

              <Route
                path="/vocs-inventory/fugitive/report-voc-series"
                element={
                  <LayoutApp>
                    <ReportFugitiveFuelVolume />
                  </LayoutApp>
                }
              ></Route>

              <Route
                path="/vocs-inventory/fugitive/report-voc-emission"
                element={
                  <LayoutApp>
                    <ReportFugitiveVocEmission />
                  </LayoutApp>
                }
              ></Route>

              <Route
                path="/vocs-inventory/fugitive/history"
                element={
                  <LayoutApp>
                    <FugitiveHistory />
                  </LayoutApp>
                }
              ></Route>

              {/* FUJITIVE ZONE */}

              {/* COMBUSTION ZONE */}
              <Route
                path="/vocs-inventory/combustion/setup-stack-information"
                element={
                  <LayoutApp>
                    <SetupStackInfo />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/combustion/setup-fuel-volume"
                element={
                  <LayoutApp>
                    <SetupFuelVolumeAndDensity />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/combustion/manual-fuel-volume"
                element={
                  <LayoutApp>
                    <ManualFuelvolume />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/combustion/manual-sampling"
                element={
                  <LayoutApp>
                    <ManualSampling />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/combustion/report-fuel-volume"
                element={
                  <LayoutApp>
                    <ReportFuelVolume />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/combustion/report-voc-emission"
                element={
                  <LayoutApp>
                    <ReportVocEmission />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/combustion/history"
                element={
                  <LayoutApp>
                    <HistoryCombustion />
                  </LayoutApp>
                }
              ></Route>
              {/* COMBUSTION ZONE */}

              {/* FLARE ZONE */}
              <Route
                path="/vocs-inventory/flare"
                element={
                  <LayoutApp>
                    <Flare />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/flare/setup-heating-value"
                element={
                  <LayoutApp>
                    <SetupHeatingValue />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/flare/setup-flare-volume"
                element={
                  <LayoutApp>
                    <SetupFlareVolume />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/flare/manual-flare-volume"
                element={
                  <LayoutApp>
                    <ManualFuelVolume />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/flare/report-flare-volume"
                element={
                  <LayoutApp>
                    <ReportFlareFuelVolume />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/flare/report-voc-emission"
                element={
                  <LayoutApp>
                    <ReportFlareVocEmission />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/flare/report-government"
                element={
                  <LayoutApp>
                    <ReportGovernment />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/flare/history"
                element={
                  <LayoutApp>
                    <FlareHistory />
                  </LayoutApp>
                }
              ></Route>
              {/* FLARE ZONE */}

              {/* TRANSPORTATION & MARKETING */}
              <Route
                path="/vocs-inventory/transportation-and-marketing"
                element={
                  <LayoutApp>
                    <TransportationMarketing />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/transportation-and-marketing/setup-loading-information"
                element={
                  <LayoutApp>
                    <SetupLoadingInfo />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/transportation-and-marketing/manual-chemical-volume"
                element={
                  <LayoutApp>
                    <TMManualVolume />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/transportation-and-marketing/report-chemical-volume"
                element={
                  <LayoutApp>
                    <TMReportChemVolume />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/transportation-and-marketing/report-voc-emission"
                element={
                  <LayoutApp>
                    <TMReportVocEmission />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/transportation-and-marketing/history"
                element={
                  <LayoutApp>
                    <TMHistory />
                  </LayoutApp>
                }
              ></Route>
              {/* TRANSPORTATION & MARKETING */}

              {/* TANK */}
              <Route
                path="/vocs-inventory/tank"
                element={
                  <LayoutApp>
                    <Tank />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/tank/setup-tank-information"
                element={
                  <LayoutApp>
                    <SetupTankInfo />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/tank/manual-voc-tank"
                element={
                  <LayoutApp>
                    <TankManualVolume />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/tank/report-voc-emission"
                element={
                  <LayoutApp>
                    <TankReportVocEmission />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/tank/history"
                element={
                  <LayoutApp>
                    <TankHistory />
                  </LayoutApp>
                }
              ></Route>
              {/* TANK */}

              {/* WASTE WATER TREATMENT */}
              <Route
                path="/vocs-inventory/waste-water-treatment"
                element={
                  <LayoutApp>
                    <WasteWaterTreatment />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/waste-water-treatment/setup-information"
                element={
                  <LayoutApp>
                    <WWTSetupInformation />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/waste-water-treatment/manual-voc-water"
                element={
                  <LayoutApp>
                    <ManualVocWater />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/waste-water-treatment/report-voc-emission"
                element={
                  <LayoutApp>
                    <WWTReportVocEmission />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/waste-water-treatment/history"
                element={
                  <LayoutApp>
                    <WWTHistory />
                  </LayoutApp>
                }
              ></Route>
              {/* WASTE WATER TREATMENT */}

              {/* Others Inventory */}
              <Route
                path="/vocs-inventory/others"
                element={
                  <LayoutApp>
                    <Others />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/others/information"
                element={
                  <LayoutApp>
                    <OthersInformation />
                  </LayoutApp>
                }
              ></Route>

              <Route
                path="/vocs-inventory/others/fill-sampling-result"
                element={
                  <LayoutApp>
                    <OtherFillSamplingResult />
                  </LayoutApp>
                }
              ></Route>

              <Route
                path="/vocs-inventory/others/fill-emission"
                element={
                  <LayoutApp>
                    <OthersFillEmission />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/others/report"
                element={
                  <LayoutApp>
                    <OthersReport />
                  </LayoutApp>
                }
              ></Route>
              <Route
                path="/vocs-inventory/others/history"
                element={
                  <LayoutApp>
                    <OthersHistory />
                  </LayoutApp>
                }
              ></Route>
              {/* Others Inventory */}

              <Route path="/unauthorized" element={<Unauthorized />} />
              <Route path="/login" element={<Login />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </div>
      </ConfigProvider>
    </HelmetProvider>
  );
};

export default App;
